/* ==========================================================================
   about.js — About 页面交互
   公共交互（菜单、订阅、返回顶部、系统识别）由 public.js 处理。
   ========================================================================== */

/* ============ 统计数据累加动画 ============ */
$(function () {
    var $stats = $('.about_stats');

    if (!$stats.length) {
        return;
    }

    var started = false;

    /* 解析 "500K+" / "98.7%" / "4.7/5" 这类数值文本 */
    function parseValue(text) {
        var match = text.match(/^(\d+(?:\.\d+)?)(.*)$/);

        if (!match) {
            return null;
        }

        return {
            target: parseFloat(match[1]),
            suffix: match[2],
            decimal: (match[1].split('.')[1] || '').length
        };
    }

    function animateValue($el) {
        var parsed = parseValue($el.text());

        if (!parsed) {
            return;
        }

        $({ current: 0 }).animate({ current: parsed.target }, {
            duration: 1000,
            easing: 'swing',
            step: function (now) {
                var value = parsed.decimal
                    ? now.toFixed(parsed.decimal)
                    : Math.round(now).toString();

                $el.text(value + parsed.suffix);
            },
            complete: function () {
                var value = parsed.decimal
                    ? parsed.target.toFixed(parsed.decimal)
                    : parsed.target.toString();

                $el.text(value + parsed.suffix);
            }
        });
    }

    function checkStats() {
        var statsTop = $stats.offset().top;
        var statsBottom = statsTop + $stats.outerHeight();
        var viewTop = $(window).scrollTop();
        var viewBottom = viewTop + $(window).height();

        /* 整个区块完整出现在视窗内后才开始动画 */
        if (statsTop >= viewTop && statsBottom <= viewBottom) {
            $stats.find('span:first-child').each(function () {
                animateValue($(this));
            });
            started = true;
            $(window).off('scroll resize', checkStats);
        }
    }

    checkStats();

    if (!started) {
        $(window).on('scroll resize', checkStats);
    }
});
